var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/other/icon-home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8437099,15.2744437 L15.3125294,4.11867835 C15.1325125,3.96044055 14.862487,3.96044055 14.6874706,4.11867835 L2.15629014,15.2744437 C2.01127648,15.4030119 1.96127177,15.6057541 2.03127836,15.7837716 C2.10128496,15.9617892 2.27630144,16.0804675 2.46631934,16.0804675 L5.75662929,16.0804675 L5.75662929,25.5351764 C5.75662929,25.7923129 5.96664907,26 6.22667356,26 L11.4521658,26 C11.7121903,26 11.9222101,25.7923129 11.9222101,25.5351764 L11.9222101,18.5628231 L18.0777899,18.5628231 L18.0777899,25.5351764 C18.0777899,25.7923129 18.2878097,26 18.5478342,26 L23.7733264,26 C24.0333509,26 24.2433707,25.7923129 24.2433707,25.5351764 L24.2433707,16.0804675 L27.5336807,16.0804675 C27.728699,16.0804675 27.898715,15.9617892 27.9687216,15.7837716 C28.0387282,15.6057541 27.9887235,15.4030119 27.8437099,15.2744437 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-9.1%",
    width: "130.8%",
    height: "136.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/other/icon-home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.5cc53f34ef065ba539e181772b841426.svg";
export { ForwardRef as ReactComponent };